import { useEffect, useState, useRef } from "react";
import "./SchoolListView.scss";
import search from "../../../Assets/Tutor/searchIconGray.svg";
import schoolIocn from "../../../Assets/School/schoolIocn.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API_END_POINTS,
  AUTHENTICATION,
  FILTER_CONSTANT,
  GLOBAL_CONSTANTS,
  ROUTES,
  getGoogleMapLink,
} from "../../../Constants/Constants";
import { axiosInstance } from "../../../Utilities/Interceptor/Interceptor";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Dropdown,
  DropdownMenuItem,
  DropdownNestedMenuItem,
} from "../Dropdown";
import Box from "@mui/material/Box";
import { store } from "../../../Redux/Store/Store";
import { setChildLoginRestriction, setErrorMessage, setErrorNotification, setLoader, setLoginSignUpOpen, setSchoolFilter } from "../../../Redux/Reducer/Reducer";
import axios from "axios";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  encryptPassData,
  getCurrentLocation,
  isObjectEmptyValue,
  nullUndefinedEmptyCheck,
} from "../../../Utilities/Helpers/Helper";
import SchoolMaps from "../../../Components/SchoolMaps/SchoolMaps";
import LikeIcon from "../../../Assets/School/schoolLikeIcon.svg";
import ShareIcon from "../../../Assets/School/shareIcon.svg";
import locationIcon from "../../../Assets/Tutor/location.svg";
import schoolImg from "../../../Assets/School/schoolImg.svg";
import { Tooltip } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import AliceCarousel from "react-alice-carousel";
import CloseIcon from "@mui/icons-material/Close";
import OpenInFullSharpIcon from "@mui/icons-material/OpenInFullSharp";
import NavigateNextSharpIcon from "@mui/icons-material/NavigateNextSharp";
import NavigateBeforeSharpIcon from "@mui/icons-material/NavigateBeforeSharp";
import card_bg from "../../../Assets/Tutor/card_bg.png";
import CalenderIcon from "../../../Assets/School/CalendarIcon.svg";
import viewOnMap from "../../../Assets/School/ViewOnMap.svg";
import curriculum from "../../../Assets/School/Curiculam.svg";
import DSIBrating from "../../../Assets/School/DSIBrating.svg";
import FoundYear from "../../../Assets/School/FoundYear.svg";
import Ranking from "../../../Assets/School/Ranking.svg";
import tutor_img from "../../../Assets/Tutor/tutor_image.png";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import SchoolFill from "../../../Assets/HeartFill/SchoolFill.svg";

import emailIcon from "../../../Assets/School/emailIcon.svg";
import websiteIcon from "../../../Assets/School/websiteIcon.svg";
import callIcon from "../../../Assets/School/callIcon.svg";
import PersonIcon from "../../../Assets/School/PersonIcon.svg";
import location_icon from "../../../Assets/Header/header_location_icon.svg";
import pdf from "../../../Assets/School/school__pdf.svg";
import WebShareComponent from "../../../Components/WebShare/WebShare";
import ExpandMap from "../../../Assets/Activities/ExpandMap.svg";
import ViewMoreLess from "../../../Components/ViewMoreCommon";
import AppFilter from "../../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SchoolListView = () => {
  const school_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL);
  const route = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const carouselRef = useRef<any>(null);
  const [searchValue, setSearchValue] = useState(school_search ? school_search :route?.state?.search_text ? route?.state?.search_text : "");
  const [triggerVal, setTriggerVal] = useState(true);
  const [schoolList, setSchoolList] = useState<any>([]);
  const [list, setList] = useState<any>([])
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>("");
  const [currentLang, setCurrentLang] = useState<any>("");
  const [PriceRangevalue, setPriceRangeValue] = useState<number[]>([0, 0]);
  const [IsTrigger, setIsTrigger] = useState<any>(null);
  const [value, setValue] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [toturDetailes, setToturDetailes] = useState<any>([]);
  const [Detailesvalue, setDetailesValue] = useState(0);
  const [currentIndex, setCurrentIndex] = useState<any>(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [ViewOnMapActive, setViewOnMapActive] = useState(
    route?.state?.map_show
  );

  const getSchoolFilter: any = useSelector((state: any) => {
    return state.filterReducer?.schoolfilter
  })

  const init_Schoolfilter: any = useSelector((state: any) => {
    return state.initFilterReducer.initSchoolfilter
  })

  
  const init_filter = {
    rating: [],
    price: [0, 0],
    curriculum: [],
    radius: 30,
    grade: [0, 15],
  }
  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [FilterData, setFilterData] = useState<any>([]);
  const [FilterApplyData, setFilterApplyData] = useState<any>(route.state?.filter ?? init_filter);
  const [radius, setRadius] = useState(init_filter.radius)
  const [initFilter, setInitFilter] = useState<any>(isObjectEmptyValue(init_Schoolfilter) ? init_Schoolfilter : init_filter);
  const [initSort, setSort] = useState<any>({
    price: '',
    rating: ''
  });

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };


  useEffect(() => {
    if (window.innerWidth < 436) {
      setIsMobileView(true);
    }
  }, []);

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      schoolList?.map((value: any, i: number) => {
        if (currentIndex - 1 === i) {
          setToturDetailes(value);
          setCurrentLat(value?.latitude);
          setCurrentLang(value?.longitude);
        }
      });
    }
  };

  const handleNext = () => {
    if (currentIndex < schoolList.length - 1) {
      setCurrentIndex(currentIndex + 1);
      schoolList?.map((value: any, i: number) => {
        if (currentIndex + 1 === i) {
          setToturDetailes(value);
          setCurrentLat(value?.latitude);
          setCurrentLang(value?.longitude);
        }
      });
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeDetailes = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setDetailesValue(newValue);
  };

  const slidePrev = () => {
    if (carouselRef?.current) {
      carouselRef?.current?.slidePrev();
    }
  };

  const slideNext = () => {
    if (carouselRef?.current) {
      carouselRef?.current?.slideNext();
    }
  };

  const syncActiveIndex = ({ item }: any) => {
    setActiveIndex(item);
  };

  const navigateSchoolDetailedView = (Detailes: any) => {
    navigate(ROUTES.SCHOOL_DETAILE_VIEW + "?id=" + encryptPassData(Detailes?.id), {
      state: { tutor_Detailes: Detailes },
    });
  };

  const CoverImg = toturDetailes?.images?.map((item: any) => {
    return (
      <>
        <img
          src={item ? item : card_bg}
          alt="card_bg" onError={(e: any) => { e.target.src = card_bg; }}
          className="card_bg_img"
        />
      </>
    );
  });

  const CoverImgEmpty = [0, 1, 2]?.map((item: any) => {
    return (
      <>
        <img src={card_bg} alt="card_bg" className="card_bg_img" />
      </>
    );
  });


  
  const handleRouteMap = () => {
    SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL, searchValue);
    navigate(ROUTES.SCHOOL_MAPS_VIEW, {
      state: {
        school_list: schoolList,
        search_text: searchValue,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLang,
        filter: FilterApplyData
      },
    });
  };
const handleOpenMap = async (data: any) => {
  const getDestination = { lat: data.latitude, lng: data.longitude };
  const mapsUrl = await getGoogleMapLink(getDestination);
  window.open(mapsUrl, "_blank");
};


  const successCallback = (position: any) => {
    const { latitude, longitude } = position.coords;
    setCurrentLat(latitude);
    setCurrentLang(longitude);
    SchoolListApi(latitude, longitude, searchValue, FilterApplyData);
  };

  const errorCallback = (error: any) => {
    
  };

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  useEffect(() => {
    if (nullUndefinedEmptyCheck(HeaderLoction?.lat && HeaderLoction?.lng) && !ViewOnMapActive) {
      setCurrentLat(HeaderLoction?.lat);
      setCurrentLang(HeaderLoction?.lng);
      if (getSchoolFilter && isObjectEmptyValue(getSchoolFilter)) {
        SchoolListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, getSchoolFilter);
      } else {
        SchoolListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, FilterApplyData);
      }
    }
  }, [HeaderLoction, route.state?.filter, ViewOnMapActive, searchValue]);

  useEffect(() => {
    if (ViewOnMapActive && schoolList?.length > 0) {
      setCurrentLat(schoolList[currentIndex]?.latitude);
      setCurrentLang(schoolList[currentIndex].longitude);
    }
  }, [ViewOnMapActive])

  useEffect(() => {
    
    
    getFilterData();
    
  }, []);

  const payload = (latitude: any, longitude: any, value: string, filtervalues: any) => {
    const filter = {
      ...filtervalues,
      grade: filtervalues.grade || [0, 15],
    }
    var payload;
    var priceValue: any = [];
    var gradeValue: any = [];
    if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
      priceValue = []
    } else if (filter.price[0] == 0 && filter.price[1] == 0) {
      priceValue = []
    } else {
      priceValue = {
        min: filter.price[0],
        max: filter.price[1],
      }
    }
    if (initFilter.grade[0] === filter.grade[0] && initFilter.grade[1] === filter.grade[1]) {
      gradeValue = []
    } else {
      gradeValue = {
        min: filter.grade[0],
        max: filter.grade[1],
      }
    }
    return payload = {
      latitude: latitude?.toString(),
      longitude: longitude?.toString(),
      radius: filter.radius,
      search: value ? value : "",
      price: priceValue,
      rating: filter.rating ?? "",
      curriculum: filter.curriculum ?? "",
      grade: gradeValue
    };
  };

  const SchoolListApi = (latitude: any, longitude: any, value: string, filter: any) => {
    var pay = payload(latitude, longitude, value, filter);
    console.log("🚀 ~ SchoolListApi ~ pay:", pay)
    axiosInstance
      .post(`${API_END_POINTS.SCHOOLLIST}`, pay)
      .then((Response: any) => {
        setList(Response?.data?.result?.data)
        if (initSort?.price || initSort?.rating || initSort?.the_rating || initSort?.sh_rating) {
          handleProceedSort(initSort?.price, initSort?.rating, Response?.data?.result?.data)
        } else {
          setSchoolList(Response?.data?.result?.data);
          setToturDetailes(Response?.data?.result?.data[0]);
        }
      })
      .catch(() => { });
  };

  const searchSchoolKeyword = (search: any) => {
    const accessToken = GetSessionStorageData(
      AUTHENTICATION.SHARED.ACCESS_TOKEN
    );
    var payload = {
      search_text: search,
      latitude: `${currentLat}`,
      longitude: `${currentLang}`,
      radius: radius
    };
    axiosInstance
      .post(`${API_END_POINTS.SCHOOL_KEY_WORD_SEARCH}`, payload)
      .then((Response: any) => {
        setSearchTextList(Response?.data.result?.data);
      })
      .catch(() => { });
  };

  const getFilterData = () => {
    axiosInstance
      .get(`${API_END_POINTS.SCHOOLFILTERLIST}`)
      .then((Response: any) => {
        if (Response?.data?.status) {
          let data = Response?.data?.result?.data;
          setFilterData(Response?.data?.result?.data);
          if (data) {
            let init = {
              price: [data.price?.min, data.price?.max],
              grade: [data.grade?.min, data.grade?.max],
              rating: [],
              curriculum: [],
              radius: 30,
            }
            setInitFilter(init);
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.SCHOOL, JSON.stringify(init));
            if (getSchoolFilter && isObjectEmptyValue(getSchoolFilter)) {
              setFilterApplyData(getSchoolFilter);
              setRadius(getSchoolFilter.radius);
            } else {
              setFilterApplyData(init);
            }
          }
          setTimeout(() => {
            setPriceRangeValue([
              Response?.data?.result?.data?.fees?.min,
              Response?.data?.result?.data?.fees?.max,
            ]);
          }, 500);
        }
      })
      .catch(() => { });
  };

  const FilterApply = (filter: any) => {
    setFilterApplyData(filter)
    setRadius(filter.radius);
    SetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.SCHOOL, JSON.stringify(filter));
    store.dispatch(setSchoolFilter(filter));
    SchoolListApi(currentLat, currentLang, searchValue, filter);
  };

  const FilterReset = () => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));

    setTimeout(() => {
      store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
      SchoolListApi(currentLat, currentLang, searchValue, FilterApplyData);
    }, 500);
  };

  const onInputChange = (value: any) => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL, value);
      if (value?.length > 2) {
        searchSchoolKeyword(value);
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    
    event.preventDefault();
    SchoolListApi(currentLat, currentLang, searchValue, FilterApplyData);
  };

  const handlePassSchoolData = (value: any) => {
    schoolList?.map((item: any, i: number) => {
      if (value === i) {
        setToturDetailes(item);
        setCurrentIndex(value);
      }
    });
    if (nullUndefinedEmptyCheck(value)) {
      setTriggerVal(true);
    } else {
      setTriggerVal(false);
    }
  };

  const handleChangeFavourites = (val: any, id: any) => {
    const accessToken = GetSessionStorageData(
      AUTHENTICATION.SHARED.ACCESS_TOKEN
    );
    if (nullUndefinedEmptyCheck(accessToken)) {
      var payload = {
        service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.FOUR_INT,
        service_provider: id,
        is_favourite: !val,
      };
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
        .then((Response: any) => {
          if (Response?.data?.status) {
            SchoolListApi(currentLat, currentLang, searchValue, FilterApplyData);
            toast.success(Response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
          }
        })
        .catch((error) => {
          
          
          
        });
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const Loader: any = useSelector((state: any) => {
    return state.loaderReducer.loader;
  });

  
  // Map container needs an explicit height so GoogleMap can render (100% may collapse)
  const containerStyle = {
    width: "100%",
    height: "400px",
  };
  // Use Redux flag to know whether Google Maps API is loaded (keeps behavior consistent)
  const isLoaded: boolean = useSelector((state: any) => state.googleMapLoadedReducer?.isGoogleMapLoaded);

  const DownloadPdf = (data: any) => {
    if (nullUndefinedEmptyCheck(data)) {
      store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      fetch(data, {
        method: "GET",
      })
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          const urlParts = data?.split('/');
          const fileName = urlParts[urlParts?.length - 1];
          a.style.display = "none";
          a.href = url;
          a.download = fileName; 
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            toast.success("Download Pdf Successfully", {
              position: "top-right",
            });
            store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
          }, 500);
        })
        .catch(() => {
          setTimeout(() => {
            store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
          }, 500);
        });
    } else {
      
      
      
      store.dispatch(setErrorNotification(true))
      store.dispatch(setErrorMessage("No data Found"))
    }
  };

  const NavigateCalendar = (url: any, id: any) => {
    if (nullUndefinedEmptyCheck(id)) {
      if (GetSessionStorageData(AUTHENTICATION.SHARED.ACCOUNT_TYPE) === AUTHENTICATION.PROFILE_ACCOUNT_TYPE.PARENT) {
        var payload = {
          school_id: id,
        };
        axiosInstance
          .post(`${API_END_POINTS.SCHOOL_CONTACT_NOTIFICATION}`, payload)
          .then((Response: any) => {
            if (Response?.data?.status) {
              
              
              toast.success(Response?.data?.message, {
                position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
              });
            }
          })
          .catch((error) => {
            
            
            
          });
      } else {
        dispatch(setChildLoginRestriction(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      }
    } else {
      
      window.open(url, "_blank");
    }
  };

  const handleChatRequest = () => {
    const accessToken = GetSessionStorageData(
      AUTHENTICATION.SHARED.ACCESS_TOKEN
    );
    if (nullUndefinedEmptyCheck(accessToken)) {
      if (GetSessionStorageData(AUTHENTICATION.SHARED.ACCOUNT_TYPE) === AUTHENTICATION.PROFILE_ACCOUNT_TYPE.PARENT) {
        axiosInstance
          .get(`${API_END_POINTS.SCHOOL_EXPERT + '?school_id=' + toturDetailes?.id}`)
          .then((Response: any) => {
            if (Response?.data?.status) {
              var status = Response?.data?.result?.data[0];
              if (status?.room_id === 0) {
                let payload = {
                  school_id: toturDetailes?.id,
                }
                axiosInstance
                  .post(`${API_END_POINTS.SCHOOL_EXPERT}`, payload)
                  .then((Response: any) => {
                    if (Response?.data?.status) {
                      var status_new = Response?.data?.result?.data[0];
                      navigate(ROUTES.SCHOOL_CHAT_VIEW, {
                        state: { roomData: status_new, is_notification: false, },
                      });
                    }
                  })
                  .catch(() => { });
              } else {
                navigate(ROUTES.SCHOOL_CHAT_VIEW, {
                  state: { roomData: status, is_notification: false, },
                });
              }
            }
          })
          .catch(() => { });
      } else {
        dispatch(setChildLoginRestriction(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
      }
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const sort: any = GetSessionStorageData("sort")
  useEffect(() => {
    let data = JSON.parse(sort)
    if (data?.price || data?.rating) {
      handleProceedSort(data?.price, data?.rating)
    }
  }, [sort])

  const handleProceedSort = (checkedPrice: any, checkedRating: any, data: any = null) => {

    const sortedData = data ? [...data] : [...list]

    if (checkedPrice == 'high') {
      sortedData.sort((a: any, b: any) => b?.least_fee - a?.least_fee);
    } else if (checkedPrice == 'low') {
      sortedData.sort((a: any, b: any) => a?.least_fee - b?.least_fee);
    } else if (checkedRating == 'high') {
      sortedData.sort((a: any, b: any) => b?.dsip_sort_rating - a?.dsip_sort_rating);
    } else if (checkedRating == 'low') {
      sortedData.sort((a: any, b: any) => a?.dsip_sort_rating - b?.dsip_sort_rating);
    }
    setSchoolList(sortedData);
    setToturDetailes(sortedData[0]);
    setSort({
      price: checkedPrice,
      rating: checkedRating
    })
  }

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const HeaderLocationName: any = useSelector((state: any) => {
    return state.locationNameReducer.locationName;
  });
 
  const Search_icon_top = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_button_eng" : "search_button_arb";
  const top_cover_img_wrapper = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "top_cover_img_wrapper" : "top_cover_img_wrapper_arb";
  const school__tap__contant = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "school__tap__contant" : "school__tap__contant_arb";


  return (
    <>
      <div className="UniversityMapsView__container school__list__view">
        <div className="row">
          <div className="col-lg-6 col-md-12 ">
            <div className="List__topView__wapper">
              <div
                className="UniversityCard_Img_wapper"
                onClick={() => navigate(ROUTES.SCHOOLLAYOUT)}
              >
                <img draggable="false" src={schoolIocn} />
                <div className="University__text">{t("Schools")}</div>
              </div>
              <div
                className={
                  ViewOnMapActive
                    ? "school__listView__Active List__topView__onMap"
                    : "List__topView__onMap"
                }
                onClick={() => setViewOnMapActive(!ViewOnMapActive)}
              >
                <img src={ExpandMap} alt="ExpandMap" />
                <span>
                  {ViewOnMapActive ? t("View on List") : t("View on Map")}{" "}
                </span>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-lg-4 col-md-12 ">
              <div className="search_field_wrapper">
                <div className="search__autocomplete">
                  <form onSubmit={handleSubmit}>
                    <Autocomplete
                      freeSolo
                      popupIcon
                      id="free-solo-2-demo"
                      value={searchValue}
                      disableClearable={false}
                      clearIcon={false}
                      onChange={(e, value) => {
                        const trimedvalue = value ? value.trim() : "";
                        setSearchValue(trimedvalue);
                        SchoolListApi(currentLat, currentLang, trimedvalue, FilterApplyData);
                        SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL, trimedvalue);
                      }}
                      options={searchTextList?.map(
                        (option: any) =>
                          language === "English" ? option?.school_name : option?.arabic_school_name || option?.school_name
                      )}
                      renderOption={(props, option) => (
                        <Box component="li" sx={[{ px: 0.5, py: 0.7 }]} {...props} className="notranslate" translate="no">
                          {option}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search for School"
                          onChange={(inputChangeEvent: any) => {
                            onInputChange(inputChangeEvent.target.value);
                          }}
                          onKeyDown={(e: any) => {
                            if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                              e.preventDefault();
                              const trimedvalue = searchValue.trim();
                              if (trimedvalue) {
                                SchoolListApi(currentLat, currentLang, searchValue, FilterApplyData);
                              }
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            type: "text",
                          }}
                        />
                      )}
                    />
                    <img
                      draggable="false"
                      src={search}
                      alt="search"
                      className={Search_icon_top}
                      onClick={() =>
                        SchoolListApi(currentLat, currentLang, searchValue, FilterApplyData)
                      }
                    />
                  </form>
                </div>

              </div>
              <Dropdown
                style={{ display: "none" }}
                trigger={
                  <></>
                }
                Submit={FilterApply}
                Reset={FilterReset}
                menu={[]}
              />
            </div>
            <div className="col-lg-8 col-md-12">
              <AppFilter
                FilterPopOpen={FilterPopOpen}
                onOpenPop={onOpenFilterPop}
                onClosePop={onCloseFilterPop}
                FilterData={FilterData}
                FilterApply={FilterApply}
                FilterApplyData={FilterApplyData}
                initFilter={initFilter}
                initSort={initSort}
                handleApplySort={handleProceedSort}
                type="school"
                color="#FFC812" />
            </div>
          </div>
          <div className="body_scroll_container mt-3">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">

              {ViewOnMapActive ? (
                <>
                  <div className="Maps__view__listPage">
                    {/* Show message until Maps API is ready and coordinates are available */}
                    {isLoaded && currentLat && currentLang ? (
                      <>
                        <SchoolMaps
                          zoom={12}
                          radius={FilterApplyData.radius * 1000}
                          lat={currentLat}
                          lang={currentLang}
                          containerStyle={containerStyle}
                          disable={true}
                          zoomControl={false}
                          clickableIcons={false}
                          draggable={false}
                          initSort={initSort}
                          UniversityList={schoolList}
                          getOneTutor={[]}
                          initFilter={initFilter}
                          filter={isObjectEmptyValue(getSchoolFilter) ? getSchoolFilter : FilterApplyData}
                          searchValue={searchValue}
                          language={language}
                        />
                        <div className="viewMap" onClick={() => handleRouteMap()}>
                          <img src={ExpandMap} alt="ExpandMap" />
                          <span>{t("View on Map")}</span>
                        </div>
                      </>
                    ) : (
                      <div style={{ padding: 24, minHeight: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div>{isLoaded ? t("Waiting for location...") : t("Loading map... Please ensure Google Maps API is available.")}</div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="mt-3 school__listView__container">
                  {schoolList?.map((item: any, i: any) => {
                    return (
                      <>
                        <div
                          className={
                            currentIndex === i && !isMobileView
                              ? "school__list__wapper school__listView__Active"
                              : "school__list__wapper"
                          }
                          key={i}
                          onClick={() => isMobileView ? navigateSchoolDetailedView(item) : handlePassSchoolData(i)}
                          onDoubleClick={() => navigateSchoolDetailedView(item)}
                        >
                          <div className="university__leftside cursor-pointer">
                            <img
                              src={
                                item?.images?.length > 0
                                  ? item?.images[0]
                                  : schoolImg
                              }
                              alt="schoolImg"
                              onError={(e: any) => {
                                e.target.src = schoolImg;
                              }}
                            />
                          </div>
                          <div className="university__rightside">
                            <div className="university__name">
                              <span
                                className="notranslate name" translate="no"
                              >
                                {language === "English" ? item?.school_name : item?.arabic_school_name || item?.school_name}
                              </span>
                              <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                                <WebShareComponent
                                  params={
                                    ROUTES.SCHOOL_DETAILE_VIEW +
                                    "?id=" +
                                    encryptPassData(item?.id)
                                  }
                                >
                                  <img src={ShareIcon} alt="" className="mb-1" />
                                </WebShareComponent>
                                <img
                                  src={item.is_favourite ? SchoolFill : LikeIcon}
                                  alt=""
                                  onClick={() =>
                                    handleChangeFavourites(
                                      item.is_favourite,
                                      item?.user
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="university__location">
                              <img src={locationIcon} alt="" />
                              <span className="location">
                                {item?.city ? item?.city : item.address}
                              </span>
                            </div>

                            <div className="row">
                              <div className="col-md-6 university__ranking mobile_view-rank">
                                <div className="text__black">{t("Curriculum")} : </div>
                                <div className="text__green" title={item?.curriculam}>
                                  {item?.curriculam ? item?.curriculam : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                                </div>
                              </div>
                              <div className="col-md-6 university__ranking  mobile_view-rank">
                                <div className="text__black">{item?.is_type ? t("Year") : t("Grade")} : </div>
                                <div className="text__green" title={item?.grade}>
                                  {item?.grade ? item?.grade : "--"}
                                </div>
                              </div>
                              <div className="col-md-6 mt-3 university__ranking">
                                <div className="text__black">{t("Founded")} : </div>
                                <div className="text__green">
                                  {item?.founded_year ? item?.founded_year : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                                </div>
                              </div>
                              <div className="col-md-6 mt-3 university__ranking">
                                <div className="text__black">{t("Average Fee")} :</div>
                                <div className="text__green">{item?.average_fee ? item?.average_fee : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}</div>
                              </div>
                            </div>

                            <div className="university__rating">
                              <div className="text__black">{t("Rating")} :</div>
                              <div className="text__green">{item?.dsip_rating ? item?.dsip_rating : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}</div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {schoolList?.length === 0 && !Loader && (
                    <>
                      <div className="No__data__contant">

                        <div className="text">{t("No Data Found")}</div>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mt-3">
              {schoolList?.length > 0 && (
                <div
                  className={
                    triggerVal
                      ? "schoolListView__rightSide__Pop"
                      : "animate-slideInRight Model__display__none"
                  }
                >
                  <div className="top__contant__wapper__school">
                    <div className="top__PageBtn__icons">
                      {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? (
                        <NavigateBeforeSharpIcon className={currentIndex > 0 ? "prev__icons" : "icons__disable"} onClick={handlePrev} />
                      ) : (
                        <NavigateNextSharpIcon className={currentIndex > 0 ? "prev__icons" : "icons__disable"} onClick={handlePrev} />
                      )}
                      <div
                        className={
                          currentIndex > 0 ? "prev__text" : "text__disable"
                        }
                        onClick={handlePrev}
                      >
                        {t("Prev")}
                      </div>
                      <div
                        className={
                          currentIndex < schoolList?.length - 1
                            ? "prev__text"
                            : "text__disable"
                        }
                        onClick={handleNext}
                      >
                        {t("Next")}
                      </div>
                      {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? (
                        <NavigateNextSharpIcon className={currentIndex < schoolList?.length - 1 ? "next__icons" : "icons__disable"} onClick={handleNext} />
                      ) : (
                        <NavigateBeforeSharpIcon className={currentIndex < schoolList?.length - 1 ? "next__icons" : "icons__disable"} onClick={handleNext} />
                      )}
                    </div>
                    <div className="top__close__icons">
                      <Tooltip title="Expanded">
                        <OpenInFullSharpIcon
                          className="expanded__icons"
                          onClick={() => navigateSchoolDetailedView(toturDetailes)}
                        />
                      </Tooltip>
                      <Tooltip title="close">
                        <CloseIcon
                          className="close__icons"
                          onClick={() => setTriggerVal(!triggerVal)}
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <div className={top_cover_img_wrapper}>
                    <div className="arrow_navs">
                      <NavigateBeforeSharpIcon
                        onClick={slidePrev}
                        className="left_arrow"
                      />
                      <NavigateNextSharpIcon
                        onClick={slideNext}
                        className="right_arrow"
                      />
                    </div>
                    <AliceCarousel
                      
                      mouseTracking
                      autoWidth
                      disableButtonsControls
                      items={
                        toturDetailes?.images?.length > 0
                          ? CoverImg
                          : CoverImgEmpty
                      }
                      disableDotsControls
                      activeIndex={activeIndex}
                      onSlideChanged={syncActiveIndex}
                      ref={carouselRef}
                    />
                    <img
                      src={
                        toturDetailes?.images.length > 0 ? toturDetailes?.images[0] : tutor_img
                      }
                      onError={(e: any) => {
                        e.target.src = tutor_img;
                      }}
                      alt="tutor_img"
                      className="profileImg"
                    />
                  </div>

                  <div className="card__container">
                    <div className="w-100">
                      <div className="user__Detailes">
                        <div className="notranslate user name" translate="no" >
                          {language === "English" ? toturDetailes?.school_name : toturDetailes?.arabic_school_name || toturDetailes?.school_name}
                        </div>
                        <div className="user__icon__wrapper cursor-pointer">
                          <WebShareComponent
                            params={
                              ROUTES.SCHOOL_DETAILE_VIEW +
                              "?id=" +
                              encryptPassData(toturDetailes?.id)
                            }
                          >
                            <img
                              src={ShareIcon}
                              alt="shareIcon"
                              className="mb-1"
                            />
                          </WebShareComponent>
                          <img
                            src={
                              toturDetailes?.is_favourite ? SchoolFill : LikeIcon
                            }
                            alt=""
                            onClick={() =>
                              handleChangeFavourites(
                                toturDetailes?.is_favourite,
                                toturDetailes?.user
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="View__on__map_School_container">
                        {nullUndefinedEmptyCheck(
                          toturDetailes?.academic_calendar
                        ) && (
                            <div
                              className="wapperDiv"
                              onClick={() =>
                                NavigateCalendar(
                                  toturDetailes?.academic_calendar,
                                  null
                                )
                              }
                            >
                              <img src={CalenderIcon} alt="" />
                              <span>{t("Academic Calendar")}</span>
                            </div>
                          )}
                        <div className="wapperDiv" onClick={() => handleOpenMap(toturDetailes)}>
                          <img src={viewOnMap} alt="" />
                          <span>{t("View on Map")}</span>
                        </div>
                      </div>

                      <div className="row School__detailed__container__">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 flexDiv">
                          <div className="detailed__container__wapper">
                            <img src={DSIBrating} alt="" />
                            <span>{t("DSIB Rating")}</span>
                          </div>
                          <div className="number">
                            {toturDetailes?.dsip_rating}
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 flexDiv">
                          <div className="detailed__container__wapper">
                            <img src={FoundYear} alt="" />
                            <span>{t("Founded")}</span>
                          </div>
                          <div className="number">
                            {toturDetailes?.founded_year ? toturDetailes?.founded_year : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 flexDiv">
                          <div className="detailed__container__wapper">
                            <img src={curriculum} alt="" />
                            <span>{t("Curriculum")}</span>
                          </div>
                          <div className="number" title={toturDetailes?.curriculam}>
                            {toturDetailes?.curriculam}
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 flexDiv">
                          <div className="detailed__container__wapper">
                            <img src={Ranking} alt="" />
                            <span>{t("Ranking")}</span>
                          </div>
                          <div className="number">{toturDetailes?.ranking ? toturDetailes?.ranking : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}</div>
                        </div>
                      </div>

                      {toturDetailes?.description && (
                        <div className="university__description__container mt-2">
                          <div className="title">{t("Description")}</div>
                          <ViewMoreLess
                            text={toturDetailes?.description}
                            maxLength={100}
                          />
                        </div>
                      )}

                      {(toturDetailes?.application_process?.length > 0 || toturDetailes?.eligibility_criteria?.length > 0) && (
                        <div className="school__Taps__container school__Taps__container__width">
                          <Box
                            sx={{
                              borderBottom: 1,
                              borderColor: "divider",
                            }}
                          >
                            <Tabs
                              className="School__Taps"
                              value={value}
                              centered
                              onChange={handleChange}
                              aria-label="basic tabs example"
                              textColor="secondary"
                              indicatorColor="secondary"
                              variant="scrollable"
                            
                            >
                              <Tab label={t("Application Process")} {...a11yProps(0)} />
                              <Tab label={t("Eligibility Criteria")} {...a11yProps(1)} />
                            </Tabs>
                          </Box>

                          <TabPanel value={value} index={0}>
                            <div className={school__tap__contant}>
                              <ul>
                                {toturDetailes?.application_process?.map(
                                  (data: any) => {
                                    return <li>{data}</li>;
                                  }
                                )}
                              </ul>
                            </div>
                          </TabPanel>
                          <TabPanel value={value} index={1}>
                            <div className={school__tap__contant}>
                              <ul>
                                {toturDetailes?.eligibility_criteria?.map(
                                  (data: any) => {
                                    return <li>{data}</li>;
                                  }
                                )}
                              </ul>
                            </div>
                          </TabPanel>
                        </div>
                      )}
                      <div className="school__Taps__container">
                        <Box
                          sx={{
                            borderBottom: 1,
                            borderColor: "divider",
                          }}
                        >
                          <Tabs
                            className="School__Taps"
                            value={Detailesvalue}
                            centered
                            onChange={handleChangeDetailes}
                            aria-label="basic tabs example"
                            textColor="secondary"
                            indicatorColor="secondary"
                            variant="scrollable"
                          
                          >
                            <Tab label={t("School Details")} {...a11yProps(0)} />
                            <Tab label={t("Fees Structure")} {...a11yProps(1)} />
                            <Tab label={t("Fees Per Year")} {...a11yProps(2)} />
                          </Tabs>
                        </Box>

                        <TabPanel value={Detailesvalue} index={0}>
                          <div className="School__personal__detailes__wapper">
                            <div className="detailes__wapper">
                              <div className="left__side">
                                <img src={websiteIcon} alt="" />
                                <span>{t("Website")}</span>
                              </div>
                              <a
                                className="link"
                                href={toturDetailes?.web_link}
                                target="_blank"
                              >
                                {toturDetailes?.web_link}
                              </a>
                            </div>
                            <div className="detailes__wapper">
                              <div className="left__side">
                                <img src={emailIcon} alt="" />
                                <span>{t("Email")}</span>
                              </div>
                              <div className="number">{toturDetailes?.email}</div>
                            </div>
                            <div className="detailes__wapper">
                              <div className="left__side">
                                <img src={callIcon} alt="" />
                                <span>{t("Call")}</span>
                              </div>
                              <div className="number">
                                {toturDetailes?.phone_number}
                              </div>
                            </div>
                          
                            <div className="detailes__wapper">
                              <div className="left__side">
                                <img src={location_icon} alt="" />
                                <span>{t("Location")}</span>
                              </div>
                              <div
                                className="text"
                                title={toturDetailes?.address}
                              >
                                {toturDetailes?.address}
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel value={Detailesvalue} index={1}>
                          <div className="School__fess__structure__wapper">
                            {toturDetailes?.fees_structure?.map((data: any) => {
                              return (
                                <div className="detailes__wapper">
                                  <div className="left__side">
                                    <span>{Object?.keys(data)}</span>
                                  </div>
                                  <div className="fees__wapper">
                                    <div className="text">{t("AED")}</div>
                                    <div className="number">
                                      {Object?.values(data)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                           
                          </div>
                        </TabPanel>
                        <TabPanel value={Detailesvalue} index={2}>
                          <div className="School__fess__per_Year__wapper">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col" className="light_text">{t("Grade\Year")}</th>
                                  <th scope="col" className="light_text">{t("Annual Fee")}</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {toturDetailes?.fees_per_year?.map((data: any) => {
                                  return (
                                    <tr>
                                      <td className="text">{data?.grade}</td>
                                      <td><div className="fees__wapper">
                                        <div className="text">{t("AED")}</div>
                                        <div className="number">{data?.fee}</div>
                                      </div></td>
                                      {data?.detail && (
                                        <td><img
                                          src={pdf}
                                          alt=""
                                          onClick={() => DownloadPdf(data?.detail)}
                                        /></td>
                                      )}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          
                          </div>
                        </TabPanel>
                      </div>

                      <div className="school_join__now_wapper">
                        <button
                          className="join__now_Btn"
                          onClick={() => {
                            const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
                            if (nullUndefinedEmptyCheck(accessToken)) {
                              
                              handleChatRequest();
                            } else {
                              dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
                            }
                          }}>
                          {t("Chat with our consultant")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default SchoolListView;
